// index.js
// Component for Product View

// Imports
import React from 'react';
import { Flex } from 'reflexbox';
import PropTypes from 'prop-types';
import Product from './Product';
import NewProduct from './NewProduct';

// Component Class
// Shows Product View
class ProductView extends React.Component {
  // Renders Component
  render() {
    var ids = this.props.products.ids.slice();
    ids.sort((a, b) => {
      var nameA = this.props.products.byId[a].name;
      var nameB = this.props.products.byId[b].name;
      return nameA.localeCompare(nameB);
    });
    return (
      <Flex align='center' justify='center' w={1}>
        <table className="pt-html-table pt-html-table-striped pt-small" style={{width: '50%', padding: '0'}}>
          <thead>
            <tr>
              <th>Produto</th>
              <th style={{width: '300px'}}>
                <center>Preço</center>
              </th>
              <th style={{width: '30px'}}>
                <center>Opções</center>
              </th>
            </tr>
          </thead>
          <tbody>
            {ids.map(id =>
              <Product
                key={id}
                product={this.props.products.byId[id]}
                rename={this.props.renameProduct}
                remove={this.props.removeProduct}
                {...this.props}
              />
            )}
            <tr>
              <td span="3">
                <NewProduct add={this.props.addProduct} />
              </td>
            </tr>
          </tbody>
        </table>
      </Flex>
    );
  }
}

// Required Properties
ProductView.propTypes = {
  products: PropTypes.object.isRequired,
  addProduct: PropTypes.func.isRequired,
  renameProduct: PropTypes.func.isRequired,
  removeProduct: PropTypes.func.isRequired,
  addUnit: PropTypes.func.isRequired,
  removeUnit: PropTypes.func.isRequired,
  renameUnit: PropTypes.func.isRequired,
  setUnitPrice: PropTypes.func.isRequired,
}

// Exports
export default ProductView;


// WEBPACK FOOTER //
// ./src/components/ProductView/index.js